import React, {useState} from 'react'
import { Tag, Eye, EyeOff } from 'lucide-react'
import { motion } from 'framer-motion'

const AxisSettingButton = ( {handleLabelSettingClick, labelState, addClass='' }) => {
    const labelStates = ['visible', 'hidden', 'auto'];
    const [showLabelTooltip, setShowLabelTooltip] = useState(false);
    const getLabelNextState = (current) => {
        const currentIndex = labelStates.indexOf(current)
        return labelStates[(currentIndex + 1) % labelStates.length]
      }
      
    const handleTouch = () => {
        setShowLabelTooltip(true);
        setTimeout(() => setShowLabelTooltip(false), 1000); // 1秒後に消す
    };
    const getStateColor = (state) => {
        switch (state) {
            case 'visible':
                return 'green-500'
            case 'hidden':
                return 'gray-400'
            case 'auto':
                return 'gray-600'
            default:
                return 'gray-600'
        }
    }
    
    return (
        <button
                onClick={() => handleLabelSettingClick(getLabelNextState)}
                className={`p-2 rounded-md hover:bg-gray-300 h-[35px] w-[35px] flex items-center ${addClass}`}
                aria-label={`タグの表示状態を切り替える（現在: ${labelState}）`}
            >
                <motion.div
                initial={false}
                animate={{
                    scale: [1, 1.2, 1],
                    rotate: [0, 10, 0],
                }}
                transition={{ duration: 0.3 }}
                className='relative'
                onMouseEnter={() => setShowLabelTooltip(true)}
                onMouseLeave={() => setShowLabelTooltip(false)}
                onTouchStart={handleTouch}
                >
                    {
                    labelState === 'auto' ? (
                        <Tag className={`h-5 w-5 text-${getStateColor(labelState)}`} />
                    ) : labelState === 'visible' ? (
                        <Eye className={`h-5 w-5 text-${getStateColor(labelState)}`} />
                    ) : labelState === 'hidden' ? (
                        <EyeOff className={`h-5 w-5 text-${getStateColor(labelState)}`} />
                    ) : null
                    }
                    {showLabelTooltip && 
                        <div className={`absolute top-6 py-1 rounded-md w-[160px] border border-color-gray text-white bg-${getStateColor(labelState)} z-[8000]`}>
                            ラベル表示：{labelState === 'auto' ? ('auto') : labelState === 'hidden' ? ('非表示') : labelState === 'visible' ? '表示' : null}
                        </div>
                    }
                    
                </motion.div>
            </button>
    )
}

export default AxisSettingButton